<div class="loader-conatiner">
  <mat-spinner class="loader-conatiner" color="accent" id="spinner-loader">
    Please wait..........
  </mat-spinner>
</div>
